export default __webpack_public_path__ + "static/media/bg-dark5.0372eb2b.jpg";